import axios from 'axios';
import config from '../config';
import store from '../store';
import {notificationConstants} from "../constants";
import { appLogout } from '../services/AuthService'


const apiVersion = config.apiVersion;



var defaultFetchConfig =
{
    baseURL: `${config.devHost}/`,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
    },
    // transformResponse: [function (data) {
    //     console.log('Raw Fetch service Data ->',data);
    //     return data;
    // }],
    // adapter: function (config) {
    //     console.log('adapter', config);
    // },
    validateStatus: function (status) {
        if (status == 401)
        {
            // appLogout();
            console.log('Fetch Response Status is ' + status+ ' -> log out.',);
        }
        else if (status == 403)
        {
            store.dispatch({
                type: notificationConstants.ERROR,
                message: 'امکان دسترسی به این بخش وجود ندارد'
            })
        }
        return status
    },
};

export var API_FETCH = axios.create(defaultFetchConfig);



export const setFetchServiceToken = (token)=>{
    axios.defaults.headers.Authorization = 'Bearer '+token;

    axios.defaults.validateStatus = function (status) {
        if (status == 401)
        {
            // appLogout();
            console.log('Fetch Response Status is ' + status+ ' -> log out.',);
        }
        else if (status == 403)
        {
            store.dispatch({
                type: notificationConstants.ERROR,
                message: 'امکان دسترسی به این بخش وجود ندارد'
            })
        }
        return status;
    };
    defaultFetchConfig.headers['Authorization'] = 'Bearer '+token;

    API_FETCH = axios.create(defaultFetchConfig);
    // alert(API_FETCH.defaults.headers.Authorization)

}
